import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { IMAGES } from '../mock';

const Methodology = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-[1280px] mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <img src={IMAGES.methodology} alt="Business methodology" className="w-full h-[460px] object-cover rounded-2xl shadow-xl" />
          <div className="absolute -bottom-6 -right-6 bg-[#0a6cb0] text-white px-8 py-6 rounded-2xl shadow-lg hidden md:block">
            <p className="text-4xl font-bold font-serif-display">15+</p>
            <p className="text-sm tracking-wider">YEARS EXPERIENCE</p>
          </div>
        </div>

        <div>
          <p className="eyebrow mb-3">BUSINESS METHODOLOGY</p>
          <h2 className="section-title text-4xl md:text-5xl mb-6">Outside the Box Solutions</h2>
          <p className="text-[#556a85] text-[16px] leading-relaxed mb-6">
            We craft tailored strategies that go beyond conventional thinking. Our team leverages years of
            expertise across finance, technology, and consulting to unlock new pathways for sustainable growth.
          </p>
          <div className="space-y-3 mb-8">
            {['Strategic Planning & Advisory','Data-driven Decision Making','Cross-industry Innovation'].map(t => (
              <div key={t} className="flex items-center gap-3 text-[#223b57]">
                <CheckCircle2 size={20} className="text-[#0a6cb0]" />
                <span className="font-medium">{t}</span>
              </div>
            ))}
          </div>
          <a href="#services" className="pill-btn pill-btn-outline">
            EXPLORE SOLUTION <ArrowRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Methodology;
